import React, { useState } from 'react'
import styles from './PreviewImage.module.scss'
import { Icon } from 'components'
import { IconMenuDots, icons } from 'assets'
import { PreviewImageProps } from './PreviewImage.types'
import { Image } from 'models'
import { getPictureIndications } from 'components/common/Picture'
import { Picture } from '@touche-lts/panel-ui/dist'


const PreviewImage = (props: PreviewImageProps) => {
  const [expandOptions, setExpandOptions] = useState(false)
  const {
    src,
    alt,
    removeItem = () => ({}),
    openImageEditor = () => ({}),
    saveOriginalDimensions = () => ({}),
    removeCropping,
    ...img
  } = props

  const optionsContainerStyle = `${styles.optionsContainer} ${expandOptions ? styles.optionsContainerExpanded : ''}`
  const iconsContainerStyle = `${styles.iconsContainer} ${expandOptions ? '' : styles.iconsContainerCollapsed}`

  return (
    <div className={styles.container}>

      <Picture
        src={src}
        alt={alt}
        saveOriginalDimensions={saveOriginalDimensions}
        indications={getPictureIndications(img as Image)}
        removeCropping={removeCropping}
      />

      <div
        className={optionsContainerStyle}
        onMouseEnter={() => setExpandOptions(true)}
        onMouseLeave={() => setExpandOptions(false)}
      >

        <IconMenuDots
          className={styles.triggerOptionsIcon}
        />

        <div className={iconsContainerStyle}>
          <Icon
            icon={icons.circleX}
            title='Remove image'
            className={styles.icon}
            onClick={removeItem}
          />
          <Icon
            icon={icons.croppingTool}
            title='Crop/position image'
            className={styles.icon}
            onClick={openImageEditor}
          />
        </div>

      </div>
    </div>
  )
}

export { PreviewImage }
